import {clockIcon, geoMarkIcon } from "../../../constants/icons";
import Button from "olive-react-myoneui/lib/Button";
import { useNavigate } from 'react-router-dom';

function RecentEventSlot({
  className, paraDescTime, paraDesc, linkDesc, link, eventBtnLabel, eventHeading, eventDay, eventMonth, eventDetailLink, eventLink
}) {

  const navigate = useNavigate();
  const isExternalLink = (url) => {
    try {
        const link = new URL(url);
        return link.protocol === "http:" || link.protocol === "https:";
    } catch (e) {
        return false;
    }
  };

  const startClickHandler = (param = false, e) => {
    if (eventLink && param === false) {
        if (isExternalLink(eventLink)) {
            window.open(eventLink, "_blank");
        } else {
            navigate(eventDetailLink);
        }
    } else {
      navigate(eventDetailLink);
    }
  };

  return (
    <div className={`${className || ""} myk__stu-event-activity p-0`}>
      <div className="desc-carousel desc-event">
        <div className="event-date">
          <h3>{eventDay}</h3>
          <h4>{eventMonth}</h4>
        </div>
        <div className="event-desc">
          <div className="event-heading d-flex align-items-center justify-content-between gap-2">
            <h1 onClick={() => startClickHandler(eventDetailLink)} style={{'cursor':'pointer'}}>{eventHeading}</h1>
            {eventBtnLabel &&
              <Button variant="outline" className="btn-round" size="sm" onClick={() => {startClickHandler()}}>
                {eventBtnLabel}
              </Button>
            }
          </div>
          <div className="icon-teacher-expiry d-flex align-items-center gap-1 mb-2">
            {clockIcon}
            <p className="p-0 m-0 d-inline-flex gap-1">
              {paraDescTime}
            </p>
          </div>
          <div className="icon-teacher-expiry d-flex align-items-center gap-1 mb-2">
            {geoMarkIcon}
            <p className="p-0 m-0 d-inline-flex gap-1">
              {paraDesc} {linkDesc && <a href={link}>{linkDesc}</a>}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentEventSlot;
